import dayjs from 'dayjs'
import { get, getDatabase, onValue, ref, remove, set } from 'firebase/database'
import { useEffect } from 'react'
import { selectLicense } from '../redux/reducers/license'
import { setAllOrderColors } from '../redux/reducers/order'
import { getFirebaseOrderColorsPath } from '../utils/getFirebaseOrderColorsPath'
import { useAppDispatch, useAppSelector } from './redux'

export const useFirebaseOrderColors = (): void => {
    const license = useAppSelector(selectLicense)

    const dispatch = useAppDispatch()

    useEffect(() => {
        ;(async () => {
            if (!license) return

            const db = getDatabase()

            const lastClearedTimestampRef = ref(
                db,
                `${license.token}/clientData/orderColorsLastClearedTimestamp`
            )
            const orderColorsRef = ref(db, getFirebaseOrderColorsPath(license.token))

            const lastClearedTimestamp = (await get(lastClearedTimestampRef)).val()

            if (lastClearedTimestamp) {
                const now = dayjs()

                const isClear = now.isAfter(dayjs(lastClearedTimestamp).add(7, 'day'))

                if (isClear && now.hour() >= 5) {
                    await remove(orderColorsRef)
                }
            }

            await set(lastClearedTimestampRef, dayjs().valueOf())

            onValue(orderColorsRef, (snapshot) => {
                const orderColors = snapshot.val()

                if (orderColors) dispatch(setAllOrderColors(orderColors))
            })
        })()
    }, [license, dispatch])
}
